<template>
  <div class="container">
    <!--    顶部基础信息-->
    <div class="topView" v-if="Object.keys(dataInfo).length > 0">
      <div class="topTitleView">
        <img :src="!isNull(dataInfo.avatar) ? dataInfo.avatar : defaultHeadImg" class="imgView96 radius50"/>
        <div class="topTitle m-l-24">{{ dataInfo.name }}</div>
      </div>
      <div class="statisticView">
        <div class="rowFlex alignitems">
          <div class="statisticItem" v-for="(item,index) in statisticItems" :key="index">
            <div class="columnFlex alignitems"
                 :style="{width: index < statisticItems.length - 1 ? 'calc(100% - 1px)' : '100%'}">
              <div class="titleView" :style="{color: item.color ? item.color : '#3B3A38'}">
                {{ item.prefix ? item.prefix : '' }}{{ getTransformData(statisticInfo[item.prop], '-') }}
              </div>
              <div class="rowFlex alignitems">
                <div class="infoView">{{ item.title }}</div>
                <img src="@/assets/image/statisticManage/tip@3x.png" class="imgView24 m-l-4 shrin" @click.stop="handleTip(item)"/>
              </div>
            </div>
            <div class="line-1e1" v-if="index < statisticItems.length - 1"></div>
          </div>
        </div>
      </div>
    </div>
    <!--    分栏信息-->
    <van-tabs
        v-if="show"
        v-model="active"
        color="#4466F5"
        line-width="24px"
        line-height="4px"
        title-active-color="#3B3A38"
        title-inactive-color="#3B3A38"
        sticky
        class="m-t-16"
        style="height: 88px"
    >
      <van-tab v-for="(item,index) in tabList" :title="item.title" :key="index" :name="item.name">
        <baseInfo v-if="active == 'baseInfo' && !isNull(id)" :corpId="corpId" :memberId="id"></baseInfo>
        <newLoseInfo v-if="active == 'newLose' && !isNull(id)" :memberId="id" :wxUserId="wxUserId"></newLoseInfo>
        <groupInfo v-if="active == 'group' && !isNull(id)" :memberId="id" :wxUserId="wxUserId" :corpId="corpId"></groupInfo>
        <memberInfo v-if="active == 'customer' && !isNull(id)" :memberId="id" :corpId="corpId"></memberInfo>
        <loseCustomerInfo v-if="active == 'loseCustomer' && !isNull(id)" :memberId="id" :corpId="corpId"></loseCustomerInfo>
      </van-tab>
    </van-tabs>
    <tipPopup
      :show="showTip"
      :title="currentTipItem.title"
      :content="currentTipItem.content"
      @close="handleTipClose"
    ></tipPopup>
  </div>
</template>

<script>
import utils from "@/utils/common";
import baseInfo from "./tabComponents/baseInfo";
import newLoseInfo from "./tabComponents/newLoseInfo";
import groupInfo from "./tabComponents/groupInfo";
import memberInfo from "./tabComponents/memberInfo";
import loseCustomerInfo from "./tabComponents/loseCustomerInfo";
import tipPopup from "../components/tipPopup.vue";
import http from "@/utils/axios";
export default ({
  components:{
    baseInfo,
    newLoseInfo,
    memberInfo,
    groupInfo,
    loseCustomerInfo,
    tipPopup
  },
  data() {
    return {
      defaultHeadImg:require('@/assets/image/statisticManage/defaultHead@3x.png'),
      id:'',
      show:'',
      memberId:'',
      wxUserId:'',
      dataInfo: {},
      corpId:'',
      showTip:false,
      currentTipItem:{},
      statisticInfo:{},
      statisticItems:[
        {
          title: '客户总数',
          prop: 'khzs',
          content:'该企微员工的外部联系人是微信用户数量总和'
        },
        {
          title: '本月新增',
          prop: 'byxz',
          content:'该企微员工本月所添加客户人数。注.含主动与被动'
        },
        {
          title: '今日新增',
          prop: 'jrxz',
          content:'该企微员工今日所添加客户人数。注.含主动与被动'
        },
        {
          title: '今日流失',
          prop: 'jrls',
          content:'该企微员工今日所流失的客户人数。注.含主动与被动'
        }
      ],
      active:'baseInfo',
      tabList:[
        {
          title:'客户构成',
          name:'baseInfo'
        },
        {
          title:'拉新流失',
          name:'newLose'
        },
        {
          title:'群列表',
          name:'group'
        },
        {
          title:'客户列表',
          name:'customer'
        },
        {
          title:'流失客户',
          name:'loseCustomer'
        }
      ]
    }
  },
  created() {
    this.$loading.hide();
    if(window.location.href.indexOf('agentid') > -1){
      this.show = true
      let code = utils.getUrlParamByKey(window.location.href,'code')
      let corpId = utils.getUrlParamByKey(window.location.href,'corpId')
      let agentId = utils.getUrlParamByKey(window.location.href,'agentid')
      let agentType = utils.getUrlParamByKey(window.location.href,'agentType')
      localStorage.setItem('agentId',agentId)
      localStorage.setItem('agentType',agentType)
      localStorage.setItem('corpId',corpId)
      this.corpId = corpId
      utils.getUserIdByWXCode(this,code,corpId).then((res) => {
        this.id = res.id
        this.memberId = res.id
        this.wxUserId = res.wxUserId
        this.active = 'baseInfo'
        this.getStatisticInfo()
      })
    }else{
      this.id = this.$route.query.id
      this.corpId = this.$route.query.corpId
      this.memberId = this.$route.query.memberId
      this.wxUserId = this.$route.query.wxUserId
      // this.getStatisticInfo()
    }
    // this.getDetailInfo()
  },
  activated(){
    this.$loading.hide();
  },
  mounted() {
    if(window.location.href.indexOf('agentid') > -1){
      utils.remoteJs('https://res.wx.qq.com/open/js/jweixin-1.2.0.js')
    }
    
    if(!utils.isNullData(localStorage.getItem('currentTab'))){
      this.active = localStorage.getItem('currentTab')
      localStorage.removeItem('currentTab')
    }
  },
  beforeRouteEnter(to,from,next){
    if(from.fullPath.indexOf('groupMemberStatisticList') > -1){
      next((vm) => {
        vm.show = true
        if(window.location.href.indexOf('agentid') > -1){
          let code = utils.getUrlParamByKey(window.location.href,'code')
          let corpId = utils.getUrlParamByKey(window.location.href,'corpId')
          let agentId = utils.getUrlParamByKey(window.location.href,'agentid')
          let agentType = utils.getUrlParamByKey(window.location.href,'agentType')
          localStorage.setItem('agentType',agentType)
          localStorage.setItem('agentId',agentId)
          localStorage.setItem('corpId',corpId)
          vm.corpId = corpId
          utils.getUserIdByWXCode(vm,code,corpId).then((res) => {
            vm.id = res.id
            vm.memberId = res.id
            vm.wxUserId = res.wxUserId
            vm.active = 'baseInfo'
            vm.getStatisticInfo()
          })
        }else{
          vm.id = vm.$route.query.id
          vm.corpId = vm.$route.query.corpId
          vm.memberId = vm.$route.query.memberId
          vm.wxUserId = vm.$route.query.wxUserId
          vm.getStatisticInfo()
          vm.active = 'baseInfo'
        }
        // vm.id = vm.$route.query.id
        // vm.corpId = vm.$route.query.corpId
        // vm.memberId = vm.$route.query.memberId
        // vm.getStatisticInfo()
        // vm.active = 'baseInfo'
      })
    }else{
      next()
    }
  },
  beforeRouteLeave(to, from, next){
    if(to.fullPath.indexOf('groupMemberStatisticList') > -1){
      this.show = false
    }
    next()
  },
  methods:{
    isNull(data){
      return utils.isNullData(data)
    },
    getStatisticInfo(){
      http({
        url: `order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getUserTjWithBase?userId=${this.id}`,
        method: "get",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.dataInfo = data
          this.statisticInfo = data.bsEnterpriseWeChatUserOneUserVo
          this.getTopStatisticInfo()
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * 查询顶部基本信息
     * */
    getDetailInfo(){
      http({
        url: `order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChatMember/findBsEnterpriseWechatGroupChatMemberDetail/${this.id}`,
        method: "get",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.dataInfo = data
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * 查询顶部统计信息
     * */
    getTopStatisticInfo(){
      http({
        url: `order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getUserVip?userId=${this.id}`,
        method: "get",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.statisticInfo = Object.assign({},this.statisticInfo,data)
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * 格式化数据
     */
    getTransformData(data, defaultValue = '') {
      if (utils.isNullData(data)) {
        return defaultValue
      }
      return data;
    },
    /**
     * 编辑群标签
     * */
    handleEditLabel(){

    },
    // 查看tip提示内容
    handleTip(item){
      this.currentTipItem = item
      this.showTip = true
    },
    handleTipClose(){
      this.showTip = false
      this.currentTipItem = {}
    }
  }
})
</script>
<style lang="less" scoped>
@import url("../style/index.css");
.container {
  width: 100%;

  .topView {
    padding: 24px 24px;
    background: #FFFFFF;

    .topTitleView {
      display: flex;
      align-items: center;

      .topTitle {
        font-size: 32px;
        font-weight: 500;
        color: #3B3A38;
        line-height: 40px;
      }
    }

    .labelView {
      font-size: 28px;
      font-weight: 400;
      color: #8C94A0;
      line-height: 36px;
    }

    .nameView {
      font-size: 28px;
      font-weight: 500;
      color: #26282A;
      line-height: 36px;
    }

    .tagView {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 120px);

      .tagItem {
        flex-shrink: 0;
        background: #4088EE;
        border-radius: 4px;
        padding: 0 6px;
        font-size: 18px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 26px;
        margin-right: 8px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .info{
      font-size: 28px;
      font-weight: 500;
      color: #26282A;
      line-height: 36px;
      margin-left: 12px;
    }
    .statisticView {
      background: rgba(68, 102, 245, 0.06);
      border-radius: 12px;
      padding: 24px 0;
      margin-top: 24px;
      .statisticItem {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .titleView {
          font-size: 36px;
          font-weight: bold;
          color: #3B3A38;
          line-height: 42px;
          margin-bottom: 10px;
        }

        .infoView {
          font-size: 24px;
          font-weight: 400;
          color: #8C94A0;
          line-height: 33px;
        }

        .line-1e1 {
          position: relative;
          width: 1px;
          height: 31px;

          &::after {
            position: absolute;
            top: 0;
            left: 0;
            content: ' ';
            width: 200%;
            height: 200%;
            background: #E1E1E1;
            transform-origin: 0 0;
            transform: scale(0.5);
          }
        }
      }
    }
  }
}
</style>
